import L from 'leaflet';
import PropTypes from 'prop-types';

import useLeafletLayer from './useLeafletLayer';

function LeafletAttributionControl(props) {
  const {
    position = 'bottomright',
    prefix,
  } = props;

  useLeafletLayer(() => L.control.attribution({ position, prefix }));

  return null;
}

LeafletAttributionControl.propTypes = {
  position: PropTypes.oneOf(['topleft', 'topright', 'bottomleft', 'bottomright']),
  prefix: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default LeafletAttributionControl;
